export const DEFAULT_INGEST_PORT = 2217;

export function getIngestBaseUrl(port?: number): string {
  const effectivePort = port ?? DEFAULT_INGEST_PORT;
  const configured = window.__3T_BRIDGE_CONFIG__?.ingestBaseUrl;
  if (configured) return configured.replace(/\/+$/, "");
  const { hostname, protocol } = window.location;
  return `${protocol}//${hostname}:${effectivePort}`;
}
